export default "__VITE_ASSET__BxB6R04r__"